import { supa } from '../components/firebase';
import { useEffect, useState } from 'react';
import { Search, Plus, Minus, PageEdit } from 'iconoir-react';
import ModalPersonal from '../components/modalPersonal';
import ModalLezione from '../components/modalLezione';
import ModalInfoPacchetto from '../components/modalInfoPacchetto';
import ActivityIndicator from '../components/activityIndicator';

function Pilates() {
  const [modalAdd, setModalAdd] = useState(false)
  const [modalLezione, setModalLezione] = useState(false)
  const [modalInfoPacchetto, setModalInfoPacchetto] = useState(false)

  const [pacchetti, setPacchetti] = useState([])
  const [search, setSearch] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [selectedPachettoPersonal, setSelectedPacchettoPersonal] = useState(null)

  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState(1)

  const openModal = (users, pacchettoPersonal) => {
    setSelectedUser(users)
    setSelectedPacchettoPersonal(pacchettoPersonal)
    setModalLezione(true)
  }

  const openModalInfoPacchetto = (user, pacchetto) => {
    setSelectedUser(user)
    setSelectedPacchettoPersonal(pacchetto)
    setModalInfoPacchetto(true)
  }


  async function getRows() {
    setLoading(true)
    let allData = [];
    let from = 0;
    const pageSize = 1000;
    let hasMore = true;

    while (hasMore) {
      const { data, error } = await supa
        .from('pacchettiAcquistati')
        .select('*,utenti(*),pacchetti(*)')
        .eq('tipo', 1)
        .order('created_at', { ascending: false })
        .order('id', { ascending: false })
        .range(from, from + pageSize - 1);

      if (error) {
        console.log("---", error);
        setLoading(false);
        return;
      }

      if (data && data.length > 0) {
        allData = [...allData, ...data];
        from += pageSize;
        hasMore = data.length === pageSize;
      } else {
        hasMore = false;
      }
    }

    allData.sort((a, b) => a.utenti.nome.localeCompare(b.utenti.nome) || a.utenti.cognome.localeCompare(b.utenti.cognome));
    setPacchetti(allData);
    setLoading(false);
  }

  async function patchRow(id) {
    setLoading(true)
    const { data, error } = await supa
      .from('pacchettiAcquistati')
      .update({ "completato": !pacchetti.find((item) => item.id === id).completato })
      .eq('id', id)
    if (error) console.log(error); setLoading(false)
    getRows()
    setLoading(false)
  }

  function alertPatch(id) {
    if (window.confirm(`Sei sicuro di voler segnare come ${!pacchetti.find((item) => item.id === id).completato ? "completato" : "non completato"}?`)) {
      patchRow(id)
    }
  }


  useEffect(() => {
    getRows()
  }
    , [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-50 to-zinc-100">
      {loading ? (
        <div className="flex items-center justify-center min-h-screen">
          <ActivityIndicator />
        </div>
      ) : (
        <>
          {modalAdd && <ModalPersonal visible={modalAdd} setVisible={setModalAdd} aggiorna={getRows} pilates={true} />}
          {modalLezione && <ModalLezione visible={modalLezione} setVisible={setModalLezione} aggiorna={getRows} utente={selectedUser} pacchetto={selectedPachettoPersonal} />}
          {modalInfoPacchetto && <ModalInfoPacchetto visible={modalInfoPacchetto} setVisible={setModalInfoPacchetto} aggiorna={getRows} utente={selectedUser} pacchetto={selectedPachettoPersonal} />}

          <div className="w-full px-4 sm:px-6 lg:px-8 py-8 space-y-6">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h1 className="text-3xl sm:text-4xl font-bold text-zinc-900">Pacchetti Pilates</h1>
                <p className="mt-1 text-sm text-zinc-600">Gestisci i pacchetti pilates acquistati</p>
              </div>
              <button 
                onClick={() => setModalAdd(true)} 
                className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-yellow-400 hover:bg-yellow-500 text-zinc-900 font-semibold rounded-xl text-sm shadow-sm hover:shadow transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              >
                <Plus className="w-4 h-4" />
                <span>Aggiungi acquisto</span>
              </button>
            </div>

            {/* Search and Filters */}
            <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 p-6">
              <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
                {/* Search Bar */}
                <div className="relative flex-1 max-w-md">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Search className="h-5 w-5 text-zinc-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Cerca utente..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="pl-10 pr-4 py-2.5 w-full bg-white border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all"
                  />
                </div>

                {/* Filter Buttons */}
                <div className="flex flex-wrap gap-2">
                  <button
                    onClick={() => setFilter(0)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      filter === 0
                        ? 'bg-blue-500 text-white shadow-md'
                        : 'bg-zinc-100 text-zinc-700 hover:bg-zinc-200'
                    }`}
                  >
                    Tutti ({pacchetti?.length})
                  </button>
                  <button
                    onClick={() => setFilter(3)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      filter === 3
                        ? 'bg-orange-500 text-white shadow-md'
                        : 'bg-zinc-100 text-zinc-700 hover:bg-zinc-200'
                    }`}
                  >
                    In scadenza ({pacchetti?.filter(i => new Date(i.fine) >= new Date() && new Date(i.fine) < new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000))?.length})
                  </button>
                  <button
                    onClick={() => setFilter(4)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      filter === 4
                        ? 'bg-red-500 text-white shadow-md'
                        : 'bg-zinc-100 text-zinc-700 hover:bg-zinc-200'
                    }`}
                  >
                    Scaduti ({pacchetti?.filter(i => new Date(i.fine) <= new Date() && i.completato === false)?.length})
                  </button>
                  <button
                    onClick={() => setFilter(1)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      filter === 1
                        ? 'bg-yellow-400 text-zinc-900 shadow-md'
                        : 'bg-zinc-100 text-zinc-700 hover:bg-zinc-200'
                    }`}
                  >
                    Non completati ({pacchetti?.filter(i => i?.completato === false)?.length})
                  </button>
                  <button
                    onClick={() => setFilter(2)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      filter === 2
                        ? 'bg-green-500 text-white shadow-md'
                        : 'bg-zinc-100 text-zinc-700 hover:bg-zinc-200'
                    }`}
                  >
                    Completati ({pacchetti?.filter(i => i?.completato === true)?.length})
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section */}
            <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden">
              <div className="overflow-x-auto">
                <div className="max-h-[calc(100vh-24rem)] overflow-y-auto">
                  <table className="w-full">
                    <thead className="bg-zinc-50 border-b border-zinc-200 sticky top-0 z-10">
                      <tr>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Nome</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Cognome</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Pacchetto</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Inizio</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Fine</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Totale</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Acconto</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Rimanente</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Sed. pacchetto</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Sed. effettuate</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Completato</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Azioni</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-zinc-100">
                      {pacchetti
                        ?.filter(i => 
                          filter === 2 ? i?.completato === true :
                          filter === 1 ? i?.completato === false :
                          filter === 3 ? (new Date(i.fine) >= new Date() && new Date(i.fine) < new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000)) :
                          filter === 4 ? (new Date(i.fine) <= new Date()) && i?.completato === false :
                          i
                        )
                        ?.filter((item) => 
                          item?.utenti?.nome?.toLowerCase()?.includes(search?.toLowerCase()) || 
                          item?.utenti?.cognome?.toLowerCase()?.includes(search?.toLowerCase())
                        )
                        .map((item, index) => (
                          <tr key={index} className="hover:bg-zinc-50 transition-colors">
                            <td className="px-6 py-4 text-sm font-medium text-zinc-900">{item?.utenti?.nome}</td>
                            <td className="px-6 py-4 text-sm font-medium text-zinc-900">{item?.utenti?.cognome}</td>
                            <td className="px-6 py-4 text-sm text-zinc-600">{item?.pacchetti?.nome}, {item?.totale} €</td>
                            <td className="px-6 py-4 text-sm text-zinc-600">{item?.inizio ? new Date(item?.inizio).toLocaleDateString('it-IT') : "-"}</td>
                            <td className="px-6 py-4 text-sm text-zinc-600">{item?.fine ? new Date(item?.fine).toLocaleDateString('it-IT') : "-"}</td>
                            <td className="px-6 py-4 text-sm font-semibold text-zinc-900">{item?.totale} €</td>
                            <td className="px-6 py-4 text-sm text-zinc-600">{item?.acconto} €</td>
                            <td className="px-6 py-4 text-sm font-semibold text-zinc-900">{item?.totale - item?.acconto} €</td>
                            <td className="px-6 py-4 text-sm text-zinc-600">{item?.pacchetti?.num_lezioni}</td>
                            <td className="px-6 py-4">
                              <div className="flex items-center gap-2">
                                <span className="text-sm font-semibold text-zinc-900">{item?.sedute_effettuate ? item?.sedute_effettuate : 0}</span>
                                <button 
                                  onClick={() => openModal(item?.utenti, item)} 
                                  className="p-1.5 bg-yellow-400 hover:bg-yellow-500 rounded-lg transition-colors"
                                >
                                  <Plus className="w-4 h-4 text-zinc-900" />
                                </button>
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <input 
                                type="checkbox" 
                                checked={item?.completato} 
                                onChange={() => alertPatch(item.id)} 
                                className="w-4 h-4 text-yellow-400 bg-zinc-100 border-zinc-300 rounded focus:ring-yellow-400 focus:ring-2 cursor-pointer"
                              />
                            </td>
                            <td className="px-6 py-4">
                              <button 
                                onClick={() => openModalInfoPacchetto(item?.utenti, item)} 
                                className="p-2 hover:bg-blue-100 rounded-lg transition-colors"
                              >
                                <PageEdit className="w-5 h-5 text-blue-600" />
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Pilates;
